// extracted by mini-css-extract-plugin
export default {"close_container":"CloseButton_close_container__gjAJ8","close":"CloseButton_close__HCt9Z"};